// extracted by mini-css-extract-plugin
export default {"proximaBold":"_db50212a","pageSpinner":"_11d90c91"};